import { Outlet } from 'react-router-dom';
import { getActions } from '../../services/index.service';
import SMSConversationLayout from '../../views/SMSConversation/SMSConversationLayout';

/**
 * Route Definition
 */
export default function route() {
  return [
    {
      path: accessRoute.SMS.path,
      private: true,
      key: accessRoute.SMS.key,
      name: 'SMS Conversations',
      belongsToSidebar: true,
      submenu: true,
      moduleKey: accessRoute.SMS.moduleKey,
      action: accessRoute.SMS.action,
      icon: accessRoute.SMS.icon,
      moduleKeys: [accessRoute.SMS.moduleKey],
      element: <Outlet />,
      children: [
        {
          private: true,
          path: accessRoute.SMS_BOOKING.path,
          key: accessRoute.SMS_BOOKING.key,
          name: 'Booking',
          belongsToSidebar: true,
          icon: accessRoute.SMS_BOOKING.icon,
          element: (
            <SMSConversationLayout channelType="BOOKING" />
          ),
          ...accessRoute.SMS_BOOKING,
        },
        {
          private: true,
          path: accessRoute.SMS_MARKETING.path,
          key: accessRoute.SMS_MARKETING.key,
          name: 'Marketing',
          belongsToSidebar: true,
          icon: accessRoute.SMS_MARKETING.icon,
          element: (
            <SMSConversationLayout channelType="MARKETING" />
          ),
          ...accessRoute.SMS_MARKETING,
        },
      ],
    },
  ];
}

/**
 * Access Route Config
 */
export const accessRoute = {
  SMS: {
    path: '/admin/sms',
    key: 'sms',
    moduleKey: 'sms',
    action: getActions('EDIT').value,
    icon: (
      <span className="nk-menu-icon">
    <em className="icon ni ni-chat-fill" />
      </span>
    ),
    order: 62,
  },

  SMS_BOOKING: {
    path: '/admin/sms/booking',
    key: 'sms.booking',
    moduleKey: 'sms',
    action: getActions('EDIT').value,
  },

  SMS_MARKETING: {
    path: '/admin/sms/marketing',
    key: 'sms.marketing',
    moduleKey: 'sms',
    action: getActions('EDIT').value,
  },
};

/**
 * Helper
 */
export const getChildrenRoutes = () => {
  return route()[0]?.children;
};
